import { makeStyles } from "@material-ui/core"

export const useStyles = makeStyles((theme) => ({
    cardNaoEncontrado: {
        margin: theme.spacing(4),
        "& .celula-grid-value": {
            whiteSpace: "normal",
            fontSize: '1rem',
            [theme.breakpoints.up("md")]: {
                fontSize: "1.2rem",
            },
            [theme.breakpoints.up("lg")]: {
                fontSize: "1.5rem",
            },
        },
        "& div svg:first-of-type": {
            width: "80px",
            height: "80px",
            margin: theme.spacing(4),
            fill: theme.palette.text.primary,
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    cardContainer: {
        width: '100%'
    }
}))
